import React from 'react';
import Video from '@reedexpo/video';
import PropTypes from 'prop-types';

const VideoWrapper = ({
  sourceUrl, posterUrl, fluid, autoplay, videoId, reactSettingsName
}) => (
  <Video sourceUrl={sourceUrl} posterUrl={posterUrl} fluid={fluid} autoplay={autoplay} videoId={videoId} reactSettingsName={reactSettingsName} />
);

VideoWrapper.defaultProps = {
  fluid: false,
  autoplay: false
};

VideoWrapper.propTypes = {
  sourceUrl: PropTypes.string.isRequired,
  posterUrl: PropTypes.string.isRequired,
  fluid: PropTypes.bool,
  autoplay: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  videoId: PropTypes.string,
  reactSettingsName: PropTypes.string
};


export { VideoWrapper };
